import React from "react";
import { useDispatch } from "react-redux";
import ReactGA from "react-ga";
import { Button } from "react95";
import styled from "styled-components";
import { setScraper } from "../../reducers/selectedScraper";
import useSelectedScraper from "../../hooks/useSelectedScraper";
import scraperConfig from "../../scraperConfig";

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    width: 70%;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Navigation = () => {
    const dispatch = useDispatch();
    const selectedScraper = useSelectedScraper();

    return (
        <Container>
            {Object.keys(scraperConfig).map((scraperName) => (
                <Button
                    key={scraperName}
                    active={selectedScraper === scraperName}
                    style={{ flex: "1 1 0", width: "0", marginRight: "4px" }}
                    onClick={() => {
                        dispatch(setScraper(scraperName));
                        ReactGA.event({
                            category: "User",
                            action: `Navigated to ${scraperName}`
                        });
                    }}
                >
                    {scraperName}
                </Button>
            ))}
            <Button style={{ flex: "1 1 0", width: "0" }}>About</Button>
        </Container>
    );
};

export default Navigation;
